<!--
 * @Author: LiZhiWei
 * @Date: 2026-01-29 14:27:01
 * @LastEditors: LiZhiWei
 * @LastEditTime: 2026-01-30 09:30:23
 * @Description: 
-->
<template>
  <div
    class="cases-card group flex-1 overflow-hidden rounded-16px bg-#F6F8FD p-32px transition-all duration-300 lt-sm:flex-none lt-sm:w-[calc(100vw-84px)] lt-sm:min-w-[calc(100vw-84px)] lt-sm:p-32px lt-sm:rounded-16px lt-sm:[scroll-snap-align:center]"
    :class="{ active: isActive }"
  >
    <div class="flex flex-col h-full">
      <img
        :src="caseItem.img"
        class="cases-card-img w-full h-218px rounded-12px lt-sm:h-320px lt-sm:rounded-12px"
        :alt="caseItem.title"
      />
      <h3
        class="cases-card-title pf-sc-semibold font-s-18px font-semibold text-main mt-24px lt-sm:font-s-32px lt-sm:mt-32px"
      >
        {{ caseItem.title }}
      </h3>
      <p
        class="cases-card-desc pf-sc-regular mt-8px font-s-14px lh-24px text-main/70 lt-sm:font-s-24px lt-sm:lh-36px lt-sm:mt-16px"
      >
        {{ caseItem.desc }}
      </p>
      <div
        class="cases-card-points mt-24px flex flex-col gap-8px flex-1 lt-sm:mt-32px lt-sm:gap-16px"
      >
        <div
          v-for="point in caseItem.points"
          :key="point.title"
          class="cases-card-point flex items-center gap-8px lt-sm:gap-12px"
        >
          <i
            class="i-custom-check-one cases-card-point-icon wh-20px mt-2px lt-sm:wh-32px"
            aria-hidden="true"
          ></i>
          <div
            class="cases-card-point-title pf-sc-semibold font-s-14px font-semibold text-main lt-sm:font-s-24px"
          >
            {{ point.title }}
          </div>
          <div
            class="cases-card-point-desc pf-sc-regular font-s-14px text-main/70 lt-sm:font-s-24px"
          >
            {{ point.itemDesc }}
          </div>
        </div>
      </div>
      <NuxtLink
        :to="caseItem.link"
        class="w-full mt-56px lt-sm:mt-48px"
        :aria-label="`查看${caseItem.title}详情`"
      >
        <button
          class="cases-btn w-full flex items-center justify-between gap-8px rounded-8px bg-white px-16px py-15px font-s-16px text-primary transition-all hover:bg-primary hover:text-white lt-sm:h-96px lt-sm:rounded-8px lt-sm:px-32px lt-sm:font-s-28px lt-sm:bg-primary lt-sm:text-white"
          tabindex="-1"
        >
          {{ caseItem.btnText }}
          <i
            class="i-custom-arrow-right-c cases-card-btn-icon wh-18px lt-sm:wh-32px lt-sm:text-white"
            aria-hidden="true"
          ></i>
        </button>
      </NuxtLink>
    </div>
  </div>
</template>

<script setup lang="ts">
  defineProps<{
    caseItem: CaseItem
    isActive?: boolean
  }>()
</script>

<style scoped lang="scss">
  .active {
    .dot {
      background-color: #0f67f8 !important;
    }
  }
</style>
